export const DEFAULT_PAGE_SIZE = 50;

export const MAXIMUM_NUMBER_ADDRESSES = 53;
